const pendingSubmissions = new Map<string, AbortController>();

const submissionKey = (sessionId: string, turnId: string): string =>
  `${sessionId}:${turnId}`;

/** Registers one browser-owned POST so Stop can abort a body that has not
 * reached durable backend acceptance yet. */
export const beginTurnSubmission = (
  sessionId: string,
  turnId: string
): AbortController => {
  const key = submissionKey(sessionId, turnId);
  pendingSubmissions.get(key)?.abort();
  const controller = new AbortController();
  pendingSubmissions.set(key, controller);
  return controller;
};

export const finishTurnSubmission = (
  sessionId: string,
  turnId: string,
  controller: AbortController
): void => {
  const key = submissionKey(sessionId, turnId);
  if (pendingSubmissions.get(key) === controller) {
    pendingSubmissions.delete(key);
  }
};

/** Returns true when a live browser POST was found and aborted. The caller
 * still sends exact server cancellation to cover the acceptance race. */
export const abortTurnSubmission = (
  sessionId: string,
  turnId: string | undefined
): boolean => {
  if (!turnId) return false;
  const controller = pendingSubmissions.get(submissionKey(sessionId, turnId));
  if (!controller) return false;
  controller.abort();
  return true;
};
